














































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import CardInputSKIstirahat from "@/components/pemeriksaan/resumeSuketV2/CardInputSKIstirahat.vue";
import moment from "moment";
import StoreSuketIstirahat from "@/store/modules/SuketIstirahat";
import { SuketIstirahatInterface } from "@/types/suket_istirahat";
import SuketIstirahat from "@/services/SuketIstirahat";
import BaseCardSuketMultiple from "./BaseCardSuketMultiple.vue";
import { appModule } from "@/store/modules/app";

@Component({
  components: {
    CardModalTtd,
    CardInputSKIstirahat,
    BaseCardSuketMultiple
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardSKIstirahat extends Vue {
  @Prop() readonly register!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  expandInput = false;
  pageTab = "tab-soap";
  modalTtd = false;
  dataSuketActive: SuketIstirahatInterface = null;

  get dataSuket(): Array<SuketIstirahatInterface> {
    return StoreSuketIstirahat.suket;
  }

  get loadContent() {
    return StoreSuketIstirahat.loading;
  }

  tglSurat(date) {
    return moment(date).format("DD-MM-YYYY");
  }

  setActive(data: SuketIstirahatInterface) {
    this.dataSuketActive = data;
  }

  edit(data: SuketIstirahatInterface) {
    this.dataSuketActive = data;
    this.showInput();
  }

  add() {
    this.dataSuketActive = null;
    this.showInput();
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SuketIstirahat.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
    this.dataSuketActive = null;
  }

  getHumanDate(date) {
    return date ? moment(date).format("DD MMMM YYYY") : "";
  }

  getHumanDateTime(date) {
    return date ? moment(date).format("DD MMMM YYYY HH:mm:ss") : "";
  }

  showSignatureModal(timeout = 0) {
    setTimeout(() => {
      this.modalTtd = true;
      if (!this.dataSuketActive) {
        this.dataSuketActive = this.dataSuket[this.dataSuket.length - 1];
      }
    }, timeout);
  }

  passTtd(value) {
    appModule.setLoading(true);

    // console.log(value);
    SuketIstirahat.sign(this.dataSuketActive.id, { password: value })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan SKDP");
          appModule.addMsgTtd("");
          StoreSuketIstirahat.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }

  remove(item) {
    SuketIstirahat.destroy(item.id).then(dt => {
      if (dt.status == 1) {
        appModule.NoticeDelay("Berhasil Hapus Surat Keterangan Istirahat");
        StoreSuketIstirahat.getSuketByRegister(this.register);
      } else {
        appModule.sendErrorAlert(dt.message);
      }
    });
  }
}
